import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import NavArrow from "../../../assets/icon/NavArrow";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux-hooks";
import { selectStaticPage } from "../../../store/slices/staticPages";
import PagesByIdCard from "./components/PagesByIdCard";
import { getStaticPageById } from "../../../api/asyncThuncks/staticPages";

const PagesById = () => {
  const dispatch = useAppDispatch();
  const { staticPageById } = useAppSelector(selectStaticPage);
  const { id } = useParams();

  useEffect(() => {
    if (id) dispatch(getStaticPageById(id));
  }, [id]);

  const stripHtml = (html?: string) => {
    return html ? html.replace(/<[^>]*>/g, "").trim() : "";
  };

  const seoDescription = staticPageById
    ? staticPageById.metaDescription || stripHtml(staticPageById.content).slice(0, 150)
    : "";

  return (
    <div className="w-full px-4 max-w-xl bg-white py-9 min-h-screen md:max-w-[1000px] md:min-h-[calc(100vh_-_180px)] ">
      {staticPageById && staticPageById.title && (
        <Helmet>
          <title>{`Радіо «Сільпо» | ${staticPageById.title}`}</title>
          <meta name="title" content={`Радіо «Сільпо» | ${staticPageById.title}`} />
          <meta property="og:title" content={`Радіо «Сільпо» | ${staticPageById.title}`} />
          <meta name="twitter:title" content={`Радіо «Сільпо» | ${staticPageById.title}`} />

          <meta name="description" content={seoDescription} />
          <meta property="og:description" content={seoDescription} />
          <meta name="twitter:description" content={seoDescription} />
        </Helmet>
      )}
      <div className="flex items-center text-sm text-[#5D6E97]">
        <Link className="pr-2" to="/">
          Головна
        </Link>
        <NavArrow />
        <div className="max-w-[13rem] text-ellipsis overflow-hidden whitespace-nowrap px-2 md:max-w-[35rem]">
          {staticPageById.title}
        </div>
      </div>
      {staticPageById && (
        <PagesByIdCard
          title={staticPageById.title}
          content={staticPageById.content}
          date={staticPageById.createdAt}
        />
      )}
    </div>
  );
};

export default PagesById;
